// Return true if window + document

'use strict';

module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/github.com+petflow+react-images@b493075cbbc68a1a48b51bede9ea2be2846996cf_75majzr67pr6dysc3w5lngjsty/~/react-images/lib/utils/canUseDom.js
// module id = 353
// module chunks = 0